const isMobileDevice = () => {
  const userAgent = navigator.userAgent || "";

  if (/Android|iPhone|iPad|iPod/i.test(userAgent)) return true;

  // iPadOS 13+ reports itself as "Macintosh", so an iPad would otherwise take the
  // desktop path.
  return /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1;
};

export default isMobileDevice;
